import { Configuration, FrontendApi } from '@ory/client';

let frontendApi: FrontendApi | null = null;

export function getOryFrontend(): FrontendApi {
  if (frontendApi) return frontendApi;
  const basePath = typeof window !== 'undefined' ? window.location.origin : '';
  frontendApi = new FrontendApi(
    new Configuration({
      basePath,
      baseOptions: {
        withCredentials: true,
      },
    })
  );
  return frontendApi;
}
